import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Alert, Link, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import { IDENTITY_VALIDATION_STATUS } from '../../../utils/identityValidation';

function showSupport() {
  if (typeof window.Intercom === 'function') window.Intercom('show');
}

export default function IdentityValidationBanner({ status, onValidate }) {
  const { t } = useTranslation(['description']);
  const isPending = status === IDENTITY_VALIDATION_STATUS.WAITING_MANUAL_REVIEW;
  const isRejected = status === IDENTITY_VALIDATION_STATUS.REJECTED;

  return (
    <Alert
      severity="warning"
      icon={<WarningAmberRoundedIcon />}
      sx={{ mb: 2, alignItems: 'flex-start', borderRadius: 2 }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: 14, mb: 0.5 }}>
        {t(
          isPending
            ? 'routes.identity_validation.pending_banner_title'
            : isRejected
            ? 'routes.identity_validation.rejected_banner_title'
            : 'routes.identity_validation.banner_title'
        )}
      </Typography>
      <Typography sx={{ fontSize: 13 }}>
        {isPending ? (
          t('routes.identity_validation.pending_banner_description')
        ) : isRejected ? (
          <Trans
            t={t}
            i18nKey="routes.identity_validation.rejected_banner_description"
            components={[
              <Link
                key="support-link"
                component="button"
                type="button"
                onClick={showSupport}
                color="inherit"
                sx={{ p: 0, fontWeight: 700 }}
              />,
            ]}
          />
        ) : (
          <>
            {t('routes.identity_validation.banner_description_prefix')}{' '}
            <Link
              component="button"
              type="button"
              onClick={onValidate}
              color="inherit"
              sx={{ p: 0, fontWeight: 700 }}
            >
              {t('routes.identity_validation.validate_now')}
            </Link>
          </>
        )}
      </Typography>
    </Alert>
  );
}
